var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "cog-address" },
    [
      _vm.readonly
        ? _c("div", { staticClass: "cog-input is-read-only" }, [
            _vm._v(
              _vm._s(
                _vm.addressType === "USAddress"
                  ? _vm.address.FullAddress
                  : _vm.address.FullInternationalAddress
              )
            )
          ])
        : _c(
            "c-row",
            [
              _vm.includeProperty("Line1") && _vm.autocomplete
                ? _c("autocomplete", {
                    staticClass:
                      "cog-input cog-address__street cog-input--full",
                    attrs: {
                      id: _vm.id + "-line1",
                      placeholder: _vm.$resource("address-line1"),
                      title: _vm.$resource("address-line1"),
                      "trigger-on-focus": false,
                      chameleon: _vm.chameleon,
                      "popper-class": `cog-cognito cog-${
                        _vm.scope
                      } cog-cognito--${
                        _vm.chameleon ? "chameleon" : "styled"
                      } cog-select-popper`,
                      "hide-loading": true,
                      "fill-on-select": false,
                      "tab-selects-suggestion": true,
                      autocomplete: _vm.browserAutocompleteState.Line1,
                      "fetch-suggestions": _vm.fetchAutocompletePredictions
                    },
                    on: { select: _vm.handleAutocompleteSelect },
                    model: {
                      value: _vm.address.Line1,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "Line1", $$v)
                      },
                      expression: "address.Line1"
                    }
                  })
                : _vm.includeProperty("Line1")
                ? _c("c-input", {
                    staticClass: "cog-address__street cog-input--full",
                    attrs: {
                      id: _vm.id + "-line1",
                      placeholder: _vm.$resource("address-line1"),
                      title: _vm.$resource("address-line1"),
                      label: _vm.$resource("address-line1"),
                      readonly: _vm.readonly,
                      autocomplete: _vm.browserAutocompleteState.Line1
                    },
                    model: {
                      value: _vm.address.Line1,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "Line1", $$v)
                      },
                      expression: "address.Line1"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.includeProperty("Line2")
                ? _c("c-input", {
                    staticClass: "cog-address__line-2 cog-input--full",
                    attrs: {
                      id: _vm.id + "-line2",
                      placeholder: _vm.$resource("address-line2"),
                      title: _vm.$resource("address-line2"),
                      label: _vm.$resource("address-line2"),
                      readonly: _vm.readonly,
                      autocomplete: _vm.browserAutocompleteState.Line2
                    },
                    model: {
                      value: _vm.address.Line2,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "Line2", $$v)
                      },
                      expression: "address.Line2"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.includeProperty("Line3")
                ? _c("c-input", {
                    staticClass: "cog-address__line-3 cog-input--full",
                    attrs: {
                      id: _vm.id + "-line3",
                      placeholder: _vm.$resource("address-line3"),
                      title: _vm.$resource("address-line3"),
                      label: _vm.$resource("address-line3"),
                      readonly: _vm.readonly,
                      autocomplete: _vm.browserAutocompleteState.Line3
                    },
                    model: {
                      value: _vm.address.Line3,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "Line3", $$v)
                      },
                      expression: "address.Line3"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.includeProperty("City")
                ? _c("c-input", {
                    staticClass: "cog-address__city cog-input--long",
                    attrs: {
                      id: _vm.id + "-city",
                      placeholder: _vm.$resource("address-city"),
                      title: _vm.$resource("address-city"),
                      label: _vm.$resource("address-city"),
                      readonly: _vm.readonly,
                      autocomplete: _vm.browserAutocompleteState.City
                    },
                    model: {
                      value: _vm.address.City,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "City", $$v)
                      },
                      expression: "address.City"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.includeProperty("State") && _vm.addressType === "USAddress"
                ? _c("c-select", {
                    ref: "State",
                    staticClass: "cog-address__state cog-input--long",
                    attrs: {
                      id: _vm.id + "-state",
                      "alternative-filter": _vm.customFilter,
                      scope: _vm.scope,
                      placeholder: _vm.$resource("address-state"),
                      title: _vm.$resource("address-state"),
                      label: _vm.$resource("address-state"),
                      options: _vm.stateOptions,
                      "filter-match": "beginning",
                      readonly: _vm.readonly,
                      chameleon: _vm.chameleon,
                      mobile: _vm.mobile,
                      autocomplete: _vm.browserAutocompleteState.State
                    },
                    on: {
                      focus: function($event) {
                        return _vm.toggleSelectBrowserAutocomplete(true)
                      },
                      blur: function($event) {
                        return _vm.toggleSelectBrowserAutocomplete(false)
                      }
                    },
                    nativeOn: {
                      change: function($event) {
                        return _vm.selectChanged.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.address.State,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "State", $$v)
                      },
                      expression: "address.State"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.includeProperty("State") && _vm.addressType !== "USAddress"
                ? _c("c-input", {
                    staticClass: "cog-address__state cog-input--long",
                    attrs: {
                      id: _vm.id + "-international-state",
                      placeholder: _vm.$resource(
                        "address-state-province-region"
                      ),
                      title: _vm.$resource("address-state-province-region"),
                      label: _vm.$resource("address-state-province-region"),
                      readonly: _vm.readonly,
                      autocomplete: _vm.browserAutocompleteState.State
                    },
                    model: {
                      value: _vm.address.State,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "State", $$v)
                      },
                      expression: "address.State"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.includeProperty("PostalCode") &&
              _vm.addressType === "USAddress"
                ? _c("c-input", {
                    staticClass: "cog-address__postal-code cog-input--medium",
                    attrs: {
                      id: _vm.id + "-zip-code",
                      placeholder: _vm.$resource("address-zip-code"),
                      title: _vm.$resource("address-zip-code"),
                      label: _vm.$resource("address-zip-code"),
                      mask: "#####-####",
                      type: _vm.mobile ? "tel" : "text",
                      readonly: _vm.readonly,
                      autocomplete: _vm.browserAutocompleteState.PostalCode
                    },
                    model: {
                      value: _vm.address.PostalCode,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "PostalCode", $$v)
                      },
                      expression: "address.PostalCode"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.includeProperty("PostalCode") &&
              _vm.addressType !== "USAddress"
                ? _c("c-input", {
                    staticClass: "cog-address__postal-code cog-input--long",
                    attrs: {
                      id: _vm.id + "-postal-code",
                      placeholder: _vm.$resource("address-postalcode"),
                      title: _vm.$resource("address-postalcode"),
                      label: _vm.$resource("address-postalcode"),
                      readonly: _vm.readonly,
                      autocomplete: _vm.browserAutocompleteState.PostalCode
                    },
                    model: {
                      value: _vm.address.PostalCode,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "PostalCode", $$v)
                      },
                      expression: "address.PostalCode"
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.includeProperty("Country") && _vm.addressType !== "USAddress"
                ? _c("c-select", {
                    ref: "Country",
                    staticClass: "cog-address__country cog-input--long",
                    attrs: {
                      id: _vm.id + "-country",
                      scope: _vm.scope,
                      placeholder: _vm.$resource("address-country"),
                      title: _vm.$resource("address-country"),
                      label: _vm.$resource("address-country"),
                      options: _vm.countryOptions,
                      "filter-match": "beginning",
                      readonly: _vm.readonly,
                      chameleon: _vm.chameleon,
                      mobile: _vm.mobile,
                      autocomplete: _vm.browserAutocompleteState.Country
                    },
                    on: {
                      focus: function($event) {
                        return _vm.toggleSelectBrowserAutocomplete(true)
                      },
                      blur: function($event) {
                        return _vm.toggleSelectBrowserAutocomplete(false)
                      }
                    },
                    nativeOn: {
                      change: function($event) {
                        return _vm.selectChanged.apply(null, arguments)
                      }
                    },
                    model: {
                      value: _vm.address.Country,
                      callback: function($$v) {
                        _vm.$set(_vm.address, "Country", $$v)
                      },
                      expression: "address.Country"
                    }
                  })
                : _vm._e()
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }